// extracted by mini-css-extract-plugin
export var card_container = "pressCard-module--card_container--a731c";
export var card_subcontainer = "pressCard-module--card_subcontainer--e9384";
export var image = "pressCard-module--image--3420b";
export var info = "pressCard-module--info--80ea2";
export var press_btn = "pressCard-module--press_btn--2a0f0";
export var press_content = "pressCard-module--press_content--7026e";
export var press_mediaHouse = "pressCard-module--press_mediaHouse--60309";
export var read_more = "pressCard-module--read_more--95215";